import routerOptions0 from "/home/circleci/project/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/circleci/project/packages/website/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}